import auth from "../../../../Auth";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { successToastr } from "../../../../../HelperMethods";
import { ErrorComponent } from "../../../../ReusableComponents";
import { filterBy } from "@progress/kendo-data-query";
import Skeleton from "react-loading-skeleton";
import ClientAdminDataService from '../../Service/DataService';
import { SCHEDULE_CREATED_MSG, SCHEDULE_UPDATED_MSG } from "../../../../Shared/AppMessages";
import { LocalizationHelper } from "../../../../../Localization/helpers/LocalizationHelper";
import { LocalizationResource } from "../../../../Shared/AppConstants";

export interface CreateScheduleProps {
    props: any;
    match?: any;
    location?: any;
    onCloseModal: any;
    onOpenModal: any;
    departmentId: string;
    locationId: string;
}

export interface CreateScheduleState {
    scheduleId: string;
    locationId: string
    departmentId: string
    departmentName: string;
    locationName: string
    scheduleName: string
    name?: string;
    clientName: string;
    description?: string;
    submitted: boolean;
    showLoader?: boolean;

}

class CreateSchedule extends React.Component<CreateScheduleProps, CreateScheduleState> {
    constructor(props: CreateScheduleProps) {
        super(props);
        this.state = {
            scheduleId: "",
            clientName: auth.getClientName(),
            name: "",
            submitted: false,
            showLoader: true,
            departmentName: "",
            locationName: "",
            scheduleName: "",
            departmentId: "",
            locationId: ""
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.getDepartment();
        if (this.props.props)
            this.setState({
                description: this.props.props.description,
                scheduleName: this.props.props.scheduleName,
                scheduleId: this.props.props.scheduleId, showLoader: false
            });
    }

    getDepartment = () => {
        const deptId = this.props.departmentId;
        const locId = this.props.locationId;
        if (!locId) return;
        this.setState({ departmentId: deptId });

        let queryParams = `$filter=locId eq ${locId}&$skip=0`;

        ClientAdminDataService.getClientLocationDepartment(queryParams)
            .then((res: any) => {
                let dept = res.data.filter((m: any) => m.id == deptId)
                if (dept && dept[0]) {
                    this.setState({
                        departmentId: deptId,
                        departmentName: dept[0].name,
                        locationName: dept[0].locationName,
                        locationId: locId,
                        showLoader: false
                    })
                }
            });

    }

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    openNew = () => {
        this.props.onOpenModal();
    };

    handleSaveAndAddAnother = () => {
        this.setState({ submitted: true })
        let data = {
            scheduleName: this.state.scheduleName,
            description: this.state.description,
            departmentId: this.state.departmentId
        };
        let deptId = this.state.departmentId;
        if (this.state.scheduleName && this.state.scheduleName.trim() != "") {
            ClientAdminDataService.saveSchedule(deptId,data).then((res) => {
                successToastr(SCHEDULE_CREATED_MSG);
                this.props.onCloseModal();
                this.setState({ scheduleId: res.data })
                setTimeout(() => {
                    this.openNew();
                }, 50);
            });
        }
    }

    handleUpdate = () => {
        this.setState({ submitted: true })
        let data = {
            scheduleName: this.state.scheduleName,
            description: this.state.description,
        };
        let scheduleId = this.state.scheduleId;
        if (this.state.scheduleName && this.state.scheduleName.trim() != "") {
            ClientAdminDataService.updateSchedule(scheduleId,data).then((res) => {
                successToastr(SCHEDULE_UPDATED_MSG);
                this.props.onCloseModal();
            });
        }
    }

    handleSaveAndClose = () => {
        this.setState({ submitted: true })
        let data = {
            scheduleName: this.state.scheduleName,
            description: this.state.description,
            departmentId: this.state.departmentId
        };
        let deptId = this.state.departmentId;
        if (this.state.scheduleName && this.state.scheduleName.trim() != "") {
            ClientAdminDataService.saveSchedule(deptId, data).then((res) => {
                successToastr(SCHEDULE_CREATED_MSG);
                this.setState({ scheduleId: res.data })
                this.props.onCloseModal();
            });
        }
    }

    render() {
        return (
            <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            {this.props.props !== undefined ? "Edit Schedule" : "Add New Schedule"}
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>
                    {this.state.showLoader &&
                        Array.from({ length: 2 }).map((item, i) => (
                            <div className="row mx-auto mt-2" key={i}>
                                {Array.from({ length: 3 }).map((item, j) => (
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                        <Skeleton width={230} />
                                        <Skeleton height={30} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    {!this.state.showLoader && (
                        <div>
                            <div className="row mt-3 mx-0">
                                <div className="col-sm-4 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold">{LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")} Name</label>
                                    <input
                                        type="text"
                                        className="form-control mt-1"
                                        disabled={true}
                                        value={this.state.locationName
                                            ? this.state.locationName : ""}
                                    />
                                </div>
                                <div className="col-sm-4 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold">{LocalizationHelper.getLocalizedTitle(LocalizationResource.Department_Label, "Department")} Name</label>
                                    <input
                                        type="text"
                                        className="form-control mt-1"
                                        disabled={true}
                                        value={this.state.departmentName ? this.state.departmentName : ""}
                                    />
                                </div>
                                <div className="col-sm-4 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold required">Schedule Name</label>
                                    <input
                                        type="text"
                                        className="form-control mt-1"
                                        placeholder="Enter Schedule Name"
                                        value={this.state.scheduleName}
                                        maxLength={100}
                                        onChange={(event) => {
                                            this.setState({ scheduleName: event.target.value });
                                        }}
                                    />
                                    {this.state.submitted && (!this.state.scheduleName || this.state.scheduleName.trim() == "") && <ErrorComponent />}
                                </div>
                            </div>
                        </div>
                    )}


                    <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                            {this.props.props 
                                ? <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleUpdate}>
                                    <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                                </button>
                                : <React.Fragment>
                                    <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSaveAndAddAnother}>
                                        <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save & Add Another
                                    </button>
                                    <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSaveAndClose}>
                                        <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save & Close
                                    </button>
                                </React.Fragment>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CreateSchedule;